export interface ActivityLogsNewValues {
  mfa_enabled_date: any | null;
  name: string | null;
  smop_usertype_code: any;
}

export const isActivityLogsNewValues = (
  obj: any
): obj is ActivityLogsNewValues =>
  typeof obj === "object" &&
  "mfa_enabled_date" in obj &&
  "name" in obj &&
  "smop_usertype_code" in obj;
